import { useMemo } from "react"

import { Tabs } from "ui-kit/components-branded/index"

export function TabsButtons({
    currentValue,
    setTab,
    hasCanceledSessions,
}: {
    currentValue: string
    setTab: (value: string) => void
    hasCanceledSessions: boolean
}) {
    const tabs = useMemo(() => {
        const plannedOptions = { name: TabsButtons.initialTab }
        const canceledOptions = { name: "Отмененные", disabledName: "Отмененные" }

        const plannedTab = {
            name: plannedOptions.name,
            disabled: false,
        }

        const pastTab = hasCanceledSessions
            ? { name: canceledOptions.name, disabled: false }
            : {
                  name: canceledOptions.disabledName,
                  disabled: true,
              }
        return [plannedTab, pastTab]
    }, [hasCanceledSessions])
    return <Tabs onHeaderClick={setTab} currentTab={currentValue} tabs={tabs} />
}

TabsButtons.initialTab = "Мои сессии"
